export default "__VITE_ASSET__Bc1V74DQ__$_?react__"